export interface ConnectedRuntimeConfig {
  supabaseUrl: string;
  supabasePublishableKey: string;
  vapidPublicKey: string | null;
  appOrigin: string;
  inviteOnly: boolean;
  chatEnabled: boolean;
}

export function connectedRuntimeRequested(): boolean {
  return import.meta.env.VITE_LADYBUG_RUNTIME === "connected";
}

export function readConnectedRuntimeConfig(): ConnectedRuntimeConfig {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() ?? "";
  const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() ?? "";
  const hostedUrl = /^https:\/\/[a-z0-9-]+\.supabase\.co$/i.test(supabaseUrl);
  const localDevelopmentUrl = import.meta.env.DEV && /^http:\/\/(127\.0\.0\.1|localhost):54321$/i.test(supabaseUrl);
  if (!hostedUrl && !localDevelopmentUrl) {
    throw new Error("VITE_SUPABASE_URL must be the exact HTTPS URL of the Ladybug Supabase project.");
  }
  if (supabasePublishableKey.length < 30) {
    throw new Error("VITE_SUPABASE_PUBLISHABLE_KEY is missing or invalid.");
  }
  return {
    supabaseUrl,
    supabasePublishableKey,
    vapidPublicKey: import.meta.env.VITE_VAPID_PUBLIC_KEY?.trim() || null,
    appOrigin: window.location.origin,
    inviteOnly: import.meta.env.VITE_LADYBUG_ENROLLMENT_MODE === "invite",
    // Connected pilot defaults chat ON. Only an explicit "false" disables it
    // so a deploy that forgets -EnableChat cannot strip messaging again.
    chatEnabled: import.meta.env.VITE_LADYBUG_CHAT_ENABLED !== "false"
  };
}
